var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".aSearchclose{fill:#bbc1c3;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "aSearchclose",
    d: "M7.062,6l4.719-4.719A.75.75,0,1,0,10.719.221L6,4.94,1.281.221A.75.75,0,1,0,.22,1.282L4.939,6,.22,10.72a.75.75,0,1,0,1.061,1.061L6,7.062l4.719,4.719a.75.75,0,1,0,1.061-1.061Z",
    transform: "translate(0 -0.001)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchClose);
export default __webpack_public_path__ + "static/media/search_close.9aecf496e2f20b05f6a604a265e79ffb.svg";
export { ForwardRef as ReactComponent };